module.exports = __webpack_public_path__ + "img/T5-B-rc8.1b61f89d.png";